(function() { window.GUID_e2f06208_7053_4bf1_83a2_92b9c15733f8 = { getGuid: function() { return "e2f06208-7053-4bf1-83a2-92b9c15733f8"; } }; })();
var CS;
(function (CS) {
    class TreeView {
        constructor(treeViewId) {
            this.minWidthOfContainer = 0;
            this.OpenDelay = 0;
            this.collapsedIds = [];
            this.expandedIds = [];
            let me = this;
            me.CalculateBodyLayout();
            me.searchString = '';
            me.TreeViewId = treeViewId;
            me.TreeViewUI = $('#' + me.TreeViewId);
            me.TreeViewUI.data('context', this);
            me.refreshUrl = me.TreeViewUI.data('refreshurl');
            let bindElementIds = me.TreeViewUI.data('bindelementids');
            if (bindElementIds != null) {
                me.BindElementIds = bindElementIds.split(',');
            }
            me.HiddenValueUI = me.TreeViewUI.find('#' + treeViewId.replace("TreeView", ""));
            me.ShowSelectedItemPath = true;
            me.PrepareTreeView();
            me.TreeViewUI.trigger("TreeViewIsLoaded", me);
        }
        Dispose() {
            let me = this;
            CS.off('menuShow.treeview');
            me.TreeViewUI.remove();
            me.inBodyTreeView.remove();
            for (var prop in me) {
                me[prop] = null;
            }
        }
        SelectedValue(index = null) {
            if (index != null) {
                if (this.lastSelectedItem != null) {
                    let values = this.lastSelectedItem.data('values');
                    if (values != null && values.length >= index) {
                        return values[index];
                    }
                }
            }
            if (this.HiddenValueUI.val() == '') {
                return null;
            }
            return this.HiddenValueUI.val();
        }
        PrepareTreeView() {
            let me = this;
            CS.off('menuShow.treeview');
            CS.on("menuShow.treeview", function (e) {
                if (me.CloseDropDown == null) {
                    CS.off("menuShow.treeview");
                }
                else {
                    me.CloseDropDown(false);
                }
            });
            me.SearchBox = me.TreeViewUI.find('.TreeViewItemSearch');
            me.SearchBox.on('keyup.' + me.TreeViewId, function (e) {
                let key = window.event ? e.keyCode : e.which;
                e.preventDefault();
                me.scanHelper.GrabInput(key);
                if (key == 13) {
                    let selectableItems = me.TreeViewUI.find('.SLCT');
                    if (selectableItems.length == 1 && me.SearchBox.val().length > 0 && !me.scanHelper.IsScanned) {
                        me.SelectTreeViewItem(selectableItems.first());
                    }
                }
                else if (key == 40) { /*Down*/
                    me.TreeViewUI.focus();
                    me.FocusPreviousNextTreeViewItems(true);
                }
                else if (key == 39 || key == 37 || key == 38 || key == 16 || key == 17 || key == 9) {
                    return;
                }
                else {
                    me.refreshTimeOutId = CS.Lag(350, function () {
                        me.Refresh(true);
                    });
                }
            });
            this.scanHelper = new CS.ScanEntryHelper();
            this.scanHelper.Scan = function (speed) {
                clearTimeout(me.refreshTimeOutId);
                me.SearchBox.trigger('Scanned', me);
                me.SearchBox.val('');
            };
            me.isDropDownStyle = me.TreeViewUI.hasClass('IsDropDownStyle');
            if (me.isDropDownStyle) {
                me.inBodyTreeView = $("<div id='" + me.TreeViewId + "InBody' class='TreeView IsDropDownStyle InBody'></div>");
            }
            me.treeViewItemsContainer = me.TreeViewUI.find('.TreeViewItemsContainer');
            if (me.isDropDownStyle) {
                me.treeViewItemsContainer = me.treeViewItemsContainer.remove().appendTo(me.inBodyTreeView); /*Sinon, pas le meme context*/
                me.table = me.treeViewItemsContainer.find('table');
                CompuSport.DOM.body.find("#" + me.TreeViewId + "InBody").remove();
                me.inBodyTreeView.appendTo(CS.body);
            }
            else {
                me.inBodyTreeView = me.treeViewItemsContainer;
            }
            me.treeViewContext = me.isDropDownStyle ? me.inBodyTreeView : me.TreeViewUI;
            me.lastSelectedItem = me.treeViewContext.find('.TreeViewItem.IsSelected');
            me.lastFocusedItem = me.lastSelectedItem;
            me.treeViewItemSelector = me.TreeViewUI.find('.TreeViewItemSelector'); /*Ne pas remplacer par treeViewContext*/
            me.treeViewEmptyItem = me.treeViewContext.find('.Empty');
            me.treeViewContext.on('dblclick', function (e) {
                e.preventDefault();
            }).on('click.' + me.TreeViewId, function (e) {
                e.preventDefault();
                let $target = $(e.target);
                me.OnTreeViewClick($target);
                return false;
            }).on('keydown.' + me.TreeViewId, function (e) {
                let $target = $(e.target);
                if ($target.hasClass('TreeViewItemSearch')) {
                    return;
                }
                e.preventDefault();
                let key = window.event ? e.keyCode : e.which;
                if (key == 40) { /*Down*/
                    me.FocusPreviousNextTreeViewItems(true);
                }
                else if (key == 38) { /*Up*/
                    me.FocusPreviousNextTreeViewItems(false);
                }
                else if (key == 39 || key == 107) { /*Right or Plus*/
                    me.ExpandTreeViewItem(me.lastFocusedItem, true);
                }
                else if (key == 37 || key == 109) { /*Left or Minus*/
                    me.CollapseTreeViewItem(me.lastFocusedItem);
                }
                else if (key == 13) {
                    if (!me.SelectTreeViewItem(me.lastFocusedItem)) {
                        me.ToggleExpansionTreeViewItem(me.lastFocusedItem);
                    }
                }
            });
            me.TreeViewItems = me.treeViewContext.find('.TreeViewItem');
            if (me.isDropDownStyle) {
                me.treeViewItemSelector.on('click', function (e) {
                    e.preventDefault();
                    if (!me.treeViewItemsContainer.is(':visible')) {
                        me.OpenDropDown();
                    }
                    else {
                        me.CloseDropDown();
                    }
                    return false;
                });
                $(window).resize(function () {
                    CS.Lag(50, function () {
                        me.CalculateBodyLayout();
                        me.PositionItemsContainer();
                    });
                });
                // If we click anywhere on the page, while the
                // dropdown is shown, it is going to be hidden:
                $(document).on('click.treeview', function () {
                    if (me.CloseDropDown == null) {
                        $(document).off('click.treeview');
                    }
                    else {
                        me.CloseDropDown();
                    }
                });
            }
            else {
                me.ScrollToSelectedElement();
                me.RestoreExpandedState();
            }
        }
        OnTreeOpeningClosing(closing = false) {
            let me = this;
            if (me.TreeViewOpeningClosing != null) {
                me.TreeViewOpeningClosing(closing);
            }
        }
        CloseDropDown(animate = true) {
            let me = this;
            if (!me.isDropDownStyle) {
                return;
            }
            me.TreeViewUI.trigger('CSClosed');
            me.TreeViewUI.removeClass('IsOpened');
            me.inBodyTreeView.removeClass('IsOpened');
            if (animate) {
                me.treeViewItemsContainer.slideUp(150);
            }
            else {
                me.treeViewItemsContainer.hide();
            }
        }
        OpenDropDown() {
            var me = this;
            me.TreeViewUI.trigger('CSOpened', me);
            setTimeout(function () {
                me.PositionItemsContainer();
                me.TreeViewUI.addClass('IsOpened');
                me.inBodyTreeView.addClass('IsOpened');
                me.ExpandSelectedItemParents();
                me.treeViewItemsContainer.slideDown(250, function () {
                    me.inBodyTreeView.focus();
                    me.ScrollToSelectedElement();
                    me.OnTreeOpeningClosing();
                });
            }, me.OpenDelay);
        }
        SetRefresh(url, callBack) {
            let me = this;
            me.refreshUrl = url;
            if (callBack != null) {
                me.refreshCallBack = callBack;
            }
        }
        ScrollToSelectedElement() {
            let me = this;
            if (me.lastSelectedItem != null && me.lastSelectedItem.length > 0) {
                me.ScrollToTreeViewItem(me.lastSelectedItem);
            }
        }
        Refresh(allExpanded = false) {
            let me = this;
            if (me.refreshUrl == "" || me.refreshUrl == null) {
                return;
            }
            let data = me.GetDatas();
            data.allExpanded = allExpanded;
            CompuSport.Ajax.Get(me.refreshUrl, data, function (response) {
                let $response = $(response);
                me.treeViewItemsContainer[0].innerHTML = $response.find('.TreeViewItemsContainer')[0].innerHTML;
                if (me.treeViewItemSelector.length > 0) {
                    me.treeViewItemSelector[0].innerHTML = $response.find('.TreeViewItemSelector')[0].innerHTML;
                }
                me.TreeViewItems = me.treeViewContext.find('.TreeViewItem');
                me.treeViewItemSelector = me.TreeViewUI.find('.TreeViewItemSelector');
                me.treeViewItemsContainer = me.treeViewContext.find('.TreeViewItemsContainer');
                me.treeViewEmptyItem = me.treeViewContext.find('.Empty');
                if (me.lastFocusedItem != null) {
                    me.lastFocusedItem = me.treeViewContext.find('.TreeViewItem[data-id="' + me.lastFocusedItem.data('id') + '"]').first();
                }
                if (me.lastSelectedItem != null) {
                    me.lastSelectedItem = me.treeViewContext.find('.TreeViewItem[data-id="' + me.lastSelectedItem.data('id') + '"]').first();
                    if (me.lastSelectedItem.length > 0) {
                        me.SelectTreeViewItem(me.lastSelectedItem, false);
                    }
                }
                me.RestoreExpandedState(allExpanded);
                //Highlight the text
                //me.TreeViewItems.find('.TreeViewItemHeader .Title').each(function (index2: number, elem: Element) {
                //    let text = $(elem).text();
                //    let index = text.toUpperCase().indexOf(data.searchText);
                //    if (index == -1) {
                //        return;
                //    }
                //    let start = text.substr(0, index);
                //    let middle = text.substr(index, data.searchText.length);
                //    let end = text.substr(index + data.searchText.length);
                //    $(elem).html(start + '<span class="Highlight">' + middle + '</span>' + end);
                //});
                me.PositionItemsContainer();
                if (me.refreshCallBack != null) {
                    me.refreshCallBack(response);
                }
            });
        }
        SelectTreeViewItemByData(dataName, dataValue) {
            let me = this;
            let treeViewItem = me.treeViewItemsContainer.find('.TreeViewItem[data-' + dataName + '="' + dataValue + '"]').first();
            me.SelectTreeViewItem(treeViewItem);
            me.ExpandSelectedItemParents();
        }
        ExpandSelectedItemParents() {
            let me = this;
            if (me.lastSelectedItem != null) {
                let parents = me.GetParentsOfTreeViewItem(me.lastSelectedItem);
                if (parents != null) {
                    let count = parents.length;
                    for (let i = 0; i < count; i++) {
                        let parent = parents[i];
                        me.ExpandTreeViewItem($(parent));
                    }
                }
            }
        }
        ClearSelection() {
            let me = this;
            if (me.lastSelectedItem != null) {
                me.lastSelectedItem.removeClass('IsSelected');
                me.lastSelectedItem = null;
                me.HiddenValueUI.val('');
                // If includeEmpty, afficher le texte du empty
                let title = "";
                if (me.treeViewEmptyItem.length > 0) {
                    title = me.ShowSelectedItemPath ? me.GetPath(me.treeViewEmptyItem) : me.treeViewEmptyItem.find('.TreeViewItemHeader').html();
                }
                me.treeViewItemSelector.find('.TreeViewItemSelectorTitle').html(title);
                me.CloseDropDown();
                if (me.TreeViewItemSelected != null) {
                    me.TreeViewItemSelected(null);
                }
            }
        }
        GetPath(treeViewItem) {
            let html = "";
            var parents = this.GetParentsOfTreeViewItem(treeViewItem);
            if (parents != null) {
                var nbLevel = parents.length;
                for (let i = nbLevel - 1; i >= 0; i--) {
                    var parent = parents[i];
                    var content = $(parent.html());
                    content.addClass('Lv' + (nbLevel - i));
                    html += content[0].outerHTML + "<td class='ic-cs-chevron-right'></td>";
                }
            }
            var treeViewItemContent = $(treeViewItem.html());
            treeViewItemContent.addClass('Lv' + (nbLevel + 1));
            html += treeViewItemContent[0].outerHTML;
            html += '<td class="ReservedSpaceOpenIcon"></td>';
            return html;
        }
        clearAndFocus() {
            let me = this;
            me.ClearSelection();
            me.lastFocusedItem = null;
            me.SearchBox.clearAndFocus();
        }
        OnTreeViewClick(clickedElement) {
            let me = this;
            let treeViewItem = clickedElement.closest('.TreeViewItem');
            if (treeViewItem.length > 0 && this.IsValidItem(treeViewItem)) {
                if ((treeViewItem.hasClass('Expandable') && !treeViewItem.hasClass('SLCT')) || clickedElement.hasClass('ExpandIcon')) {
                    me.ToggleExpansionTreeViewItem(treeViewItem);
                }
                else {
                    me.OnTreeViewItemClicked(treeViewItem);
                }
                me.FocusTreeViewItem(treeViewItem);
                return true;
            }
            return false;
        }
        OnTreeViewItemClicked(treeViewItem) {
            let me = this;
            if (me.TreeViewItemClicked != null) {
                me.TreeViewItemClicked(treeViewItem);
            }
            if (me.lastSelectedItem != treeViewItem) {
                me.SelectTreeViewItem(treeViewItem);
            }
        }
        SelectTreeViewItem(treeViewItem, raiseEvent = true) {
            if (treeViewItem == null) {
                return;
            }
            let me = this;
            if (treeViewItem.hasClass('SLCT')) {
                if (me.lastSelectedItem != null) {
                    me.lastSelectedItem.removeClass('IsSelected');
                }
                me.lastSelectedItem = treeViewItem;
                me.lastSelectedItem.addClass('IsSelected');
                me.HiddenValueUI.val(treeViewItem.data('id'));
                let title = '';
                if (me.ShowSelectedItemPath) {
                    title = me.GetPath(treeViewItem);
                }
                else {
                    title = treeViewItem.html();
                }
                me.treeViewItemSelector.find('.TreeViewItemSelectorTitle').html(title);
                me.CloseDropDown();
                if (me.TreeViewItemSelected != null) {
                    if (raiseEvent) {
                        me.TreeViewItemSelected(treeViewItem);
                        me.TreeViewUI.trigger('change');
                    }
                    return true;
                }
            }
            return false;
        }
        ToggleExpansionTreeViewItem(treeViewItem) {
            if (treeViewItem == null) {
                return;
            }
            let me = this;
            if (treeViewItem.hasClass('Expanded')) {
                me.CollapseTreeViewItem(treeViewItem);
                me.AddToCollapsedState(treeViewItem);
                me.RemoveFromExpandedState(treeViewItem);
            }
            else {
                me.ExpandTreeViewItem(treeViewItem, true);
                me.AddToExpandedState(treeViewItem);
                me.RemoveFromCollapsedState(treeViewItem);
            }
        }
        ExpandTreeViewItem(treeViewItem, scrollToBestChildElement = false) {
            if (treeViewItem == null || !treeViewItem.hasClass('Expandable')) {
                return;
            }
            let me = this;
            treeViewItem.addClass('Expanded');
            let treeViewItems = me.ExpandCollapseTreeItemChilds(treeViewItem, false);
            me.FlipTreeViewExpandIcon(treeViewItem);
            if (scrollToBestChildElement) {
                CS.Lag(250, function () {
                    let end = treeViewItems.length;
                    let selectedChild = null;
                    for (let i = 0; i < end; i++) {
                        var item = $(treeViewItems[i]);
                        if (item.hasClass('IsSelected')) {
                            selectedChild = item;
                            break;
                        }
                    }
                    if (selectedChild != null) {
                        me.ScrollToTreeViewItem(selectedChild);
                    }
                    else {
                        let lastChild = treeViewItems.last();
                        if (lastChild.length == 0) {
                            return;
                        }
                        me.ScrollToTreeViewItem(lastChild, treeViewItem);
                    }
                });
            }
        }
        CollapseTreeViewItem(treeViewItem) {
            if (treeViewItem == null) {
                return;
            }
            let me = this;
            if (!treeViewItem.hasClass('Expanded')) {
                let parent = me.GetParentsOfTreeViewItem(treeViewItem);
                if (parent != null && parent.length > 0) {
                    me.CollapseTreeViewItem(parent[0]);
                    me.FocusTreeViewItem(parent[0]);
                }
            }
            else {
                treeViewItem.removeClass('Expanded');
                this.ExpandCollapseTreeItemChilds(treeViewItem, true);
                me.FlipTreeViewExpandIcon(treeViewItem);
            }
        }
        ExpandCollapseTreeItemChilds(treeViewItemParent, forceNotExpanded) {
            let subItems = this.GetChildsOfTreeViewItem(treeViewItemParent);
            if (treeViewItemParent.hasClass('Expanded') && !forceNotExpanded) {
                subItems.removeClass('H'); /*H = Hidden*/
            }
            else {
                subItems.addClass('H'); /*H = Hidden*/
                forceNotExpanded = true;
            }
            let end = subItems.length;
            for (var i = 0; i < end; i++) {
                var item = $(subItems[i]);
                if (item.hasClass('Expanded')) {
                    this.ExpandCollapseTreeItemChilds(item, forceNotExpanded);
                }
            }
            return subItems;
        }
        GetChildsOfTreeViewItem(treeViewItem) {
            var parentLevel = treeViewItem.data('i');
            let subItems = this.treeViewItemsContainer.find('tr[data-p=' + parentLevel + ']');
            return subItems;
        }
        GetParentsOfTreeViewItem(treeViewItem, parents) {
            var parentLevel = treeViewItem.data('p');
            let parentItem = this.treeViewItemsContainer.find('tr[data-i=' + parentLevel + ']');
            if (parentItem.length > 0) {
                if (parents == null) {
                    parents = [];
                }
                parents.push(parentItem);
                return this.GetParentsOfTreeViewItem(parentItem, parents);
            }
            return parents;
        }
        ScrollToTreeViewItem(treeViewItem, treeViewItemLimitTopScroll) {
            let me = this;
            if (!this.IsValidItem(treeViewItem)) {
                return;
            }
            let scrollPosition = 0;
            let container = me.inBodyTreeView;
            let containerTop = container.offset().top;
            let containerHeight = container.height();
            let containerScroll = container.scrollTop();
            let containerBottom = containerTop + containerHeight;
            let itemTop = treeViewItem.offset().top;
            let itemHeight = treeViewItem.height();
            let itemBottom = itemTop + itemHeight;
            let itemIsVisible = ((itemBottom <= containerBottom) && (itemTop >= containerTop));
            /*Si l'item que l'on veut scroller vers est déjà visible, le scroll ne bouge pas*/
            if (itemIsVisible) {
                return;
            }
            /*Calcul le scroll a atteindre pour afficher l'element au bas de la liste*/
            scrollPosition = containerScroll + itemTop - containerTop - (containerHeight - itemHeight);
            /*Ici, une limite du scroll est imposé par treeViewItemLimitTopScroll qui correspond normalement au parent expandé.
            Ainsi, si le parent expandé dépasserait le haut du conteneur, le scroll s'arrêtera vis a vis le parent*/
            if (treeViewItemLimitTopScroll != null) {
                var limitTop = treeViewItemLimitTopScroll.offset().top - containerTop + containerScroll;
                if (scrollPosition > limitTop) {
                    scrollPosition = limitTop;
                }
            }
            container.animate({ scrollTop: scrollPosition }, 100, function () { });
        }
        isScrolledIntoView(treeViewItem, container) {
            //A implementer pour le keyboard
        }
        FlipTreeViewExpandIcon(treeViewItem) {
            var expandIcon = treeViewItem.find('.ExpandIcon ');
            if (treeViewItem.hasClass('Expanded')) {
                expandIcon.removeClass('ic-cs-chevron-right');
                expandIcon.addClass('ic-cs-chevron-down');
            }
            else {
                expandIcon.addClass('ic-cs-chevron-right');
                expandIcon.removeClass('ic-cs-chevron-down');
            }
        }
        FocusPreviousNextTreeViewItems(goDown) {
            let me = this;
            if (me.lastFocusedItem != null) {
                let start = 0;
                let end = 0;
                let nextIndex;
                if (goDown) {
                    end = me.TreeViewItems.length;
                }
                else {
                    start = me.TreeViewItems.length;
                    end = -1;
                }
                if (goDown) {
                    for (let i = start; i < end; i++) {
                        let item = me.TreeViewItems[i];
                        if (item == me.lastFocusedItem[0]) {
                            nextIndex = i + 1;
                            break;
                        }
                    }
                    if (nextIndex == null) {
                        nextIndex = 0;
                    }
                    for (let i = nextIndex; i < end; i++) {
                        let $item = $(me.TreeViewItems[i]);
                        if (this.IsValidItem($item)) {
                            if (me.FocusTreeViewItem($item)) {
                                break;
                            }
                        }
                    }
                }
                else {
                    for (let i = start; i > end; i--) {
                        let item = me.TreeViewItems[i];
                        if (item == me.lastFocusedItem[0]) {
                            nextIndex = i - 1;
                            break;
                        }
                    }
                    if (nextIndex == null) {
                        nextIndex = 0;
                    }
                    else if (nextIndex == -1) {
                        if (me.SearchBox.length > 0 && me.SearchBox.is(':visible')) {
                            me.SearchBox.focus();
                            me.SearchBox.select();
                        }
                    }
                    for (let i = nextIndex; i > end; i--) {
                        let $item = $(me.TreeViewItems[i]);
                        if (this.IsValidItem($item)) {
                            if (me.FocusTreeViewItem($item)) {
                                break;
                            }
                        }
                    }
                }
            }
            else {
                me.FocusTreeViewItem($(me.TreeViewItems[0]));
            }
        }
        FocusTreeViewItem(treeViewItem) {
            let me = this;
            if (treeViewItem.children().hasClass('ParentHidden') || !this.IsValidItem(treeViewItem)) {
                return false;
            }
            if (me.lastFocusedItem != null) {
                me.lastFocusedItem.removeClass('IsFocused');
            }
            me.lastFocusedItem = treeViewItem;
            me.lastFocusedItem.addClass('IsFocused');
            return true;
        }
        CalculateBodyLayout() {
            var result = CS.body[0].getBoundingClientRect();
            this.BodyLayout = {
                top: result.top,
                left: result.left,
                width: result.width,
                height: result.height
            };
        }
        PositionItemsContainer() {
            let me = this;
            if (!me.isDropDownStyle) {
                return;
            }
            var selectorPosition = me.treeViewItemSelector.offset();
            var bodyWidth = me.BodyLayout.width;
            var itemsContainerLeft = selectorPosition.left;
            var itemsContainerWidth = me.treeViewItemsContainer.outerWidth();
            var selectorWidth = me.treeViewItemSelector.outerWidth();
            if (me.minWidthOfContainer == 0) {
                me.minWidthOfContainer = itemsContainerWidth;
            }
            if (selectorWidth > itemsContainerWidth) {
                me.inBodyTreeView.css({
                    "min-width": (selectorWidth - 10) + 'px'
                });
            }
            else {
                me.inBodyTreeView.css({
                    "min-width": 'auto'
                });
            }
            if (bodyWidth <= me.minWidthOfContainer) {
                me.inBodyTreeView.addClass('Overflow');
                me.inBodyTreeView.css({
                    top: (selectorPosition.top + me.treeViewItemSelector.outerHeight()) + 'px',
                    left: 0
                });
            }
            else {
                me.inBodyTreeView.removeClass('Overflow');
                if (itemsContainerLeft + me.minWidthOfContainer > bodyWidth) {
                    me.inBodyTreeView.addClass('OverflowRight');
                    me.inBodyTreeView.css({
                        top: (selectorPosition.top + me.treeViewItemSelector.outerHeight()) + 'px',
                        left: 'auto'
                    });
                }
                else {
                    me.inBodyTreeView.removeClass('OverflowRight');
                    me.inBodyTreeView.css({
                        top: (selectorPosition.top + me.treeViewItemSelector.outerHeight()) + 'px',
                        left: itemsContainerLeft + 'px'
                    });
                }
            }
        }
        GetDatas() {
            let me = this;
            let searchText = me.SearchBox.length > 0 ? me.SearchBox.val() : me.searchString;
            //if (me.SearchBox.hasClass('watermark')) {
            //    searchText = '';
            //}
            let data = {
                searchText: searchText,
                allExpanded: false,
                selectedValue: me.SelectedValue(),
            };
            if (me.BindElementIds != null && me.BindElementIds[0] != "") {
                $.each(me.BindElementIds, function (index, id) {
                    let element = $('#' + id);
                    //Permet de fonctionner avec les radio buttons grace à ca puisque
                    //le radio button n'a pas de Id
                    if (element.length == 0) {
                        element = $('[name="' + id + '"]:checked');
                    }
                    let value = element.val();
                    if (value != null && value != "") {
                        data[id] = value.replace(" ", "_");
                    }
                });
            }
            return data;
        }
        IsValidItem(treeViewItem) {
            return !treeViewItem.hasClass('H');
        }
        getCollapsedStateKey() {
            return 'TreeViewCollapsed_' + this.TreeViewId;
        }
        getExpandedStateKey() {
            return 'TreeViewExpanded_' + this.TreeViewId;
        }
        AddToCollapsedState(treeViewItem) {
            let me = this;
            let id = treeViewItem.data('id');
            if (id == null)
                return;
            let idStr = id.toString();
            if (me.collapsedIds.indexOf(idStr) === -1) {
                me.collapsedIds.push(idStr);
            }
            me.SaveCollapsedState();
        }
        RemoveFromCollapsedState(treeViewItem) {
            let me = this;
            let id = treeViewItem.data('id');
            if (id == null)
                return;
            let idStr = id.toString();
            let index = me.collapsedIds.indexOf(idStr);
            if (index > -1) {
                me.collapsedIds.splice(index, 1);
            }
            me.SaveCollapsedState();
        }
        AddToExpandedState(treeViewItem) {
            let me = this;
            let id = treeViewItem.data('id');
            if (id == null)
                return;
            let idStr = id.toString();
            if (me.expandedIds.indexOf(idStr) === -1) {
                me.expandedIds.push(idStr);
            }
            me.SaveExpandedState();
        }
        RemoveFromExpandedState(treeViewItem) {
            let me = this;
            let id = treeViewItem.data('id');
            if (id == null)
                return;
            let idStr = id.toString();
            let index = me.expandedIds.indexOf(idStr);
            if (index > -1) {
                me.expandedIds.splice(index, 1);
            }
            me.SaveExpandedState();
        }
        SaveCollapsedState() {
            let me = this;
            if (!CSParameters.IsConnected)
                return;
            var data = { keyName: me.getCollapsedStateKey(), value: me.collapsedIds.join('||') }; /*les ids contienne des virgules,_ et | donc || peut etre ok.*/
            CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId, data);
        }
        SaveExpandedState() {
            let me = this;
            if (!CSParameters.IsConnected)
                return;
            var data = { keyName: me.getExpandedStateKey(), value: me.expandedIds.join('||') };
            CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId, data);
        }
        RestoreExpandedState(allExpanded = false) {
            let me = this;
            // Load expanded IDs and expand them
            let expandedState = me.TreeViewUI.data('expanded-state');
            if (expandedState && expandedState !== '') {
                me.expandedIds = expandedState.toString().split('||');
                for (let i = 0; i < me.expandedIds.length; i++) {
                    let item = me.treeViewItemsContainer.find('.TreeViewItem[data-id="' + me.expandedIds[i] + '"]');
                    if (item.length > 0 && !item.hasClass('Expanded')) {
                        me.ExpandTreeViewItem(item, false);
                    }
                }
            }
            else {
                me.expandedIds = [];
            }
            // Load collapsed IDs and collapse them - skip if all items should be expanded
            if (!allExpanded) {
                let collapsedState = me.TreeViewUI.data('collapsed-state');
                if (collapsedState && collapsedState !== '') {
                    me.collapsedIds = collapsedState.toString().split('||');
                    for (let i = 0; i < me.collapsedIds.length; i++) {
                        let item = me.treeViewItemsContainer.find('.TreeViewItem[data-id="' + me.collapsedIds[i] + '"]');
                        if (item.length > 0 && item.hasClass('Expanded')) {
                            me.CollapseTreeViewItem(item);
                        }
                    }
                }
                else {
                    me.collapsedIds = [];
                }
            }
            else {
                me.collapsedIds = [];
            }
        }
    }
    CS.TreeView = TreeView;
})(CS || (CS = {}));

//# sourceMappingURL=TreeView.js.map
